import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  collapsibleTitle: {
    id: 'admin.portal.productTours.collapsible.title',
    defaultMessage: 'Quick Start Guide',
    description: 'Title for the product tours collapsible component.',
  },
  collapsibleIntro: {
    id: 'admin.portal.productTours.adminOnboarding.collapsible.intro',
    defaultMessage: 'Select any item in the guide to learn more about your administrative portal.',
    description: 'Introductory text at the top of the product tours collapsible component.',
  },
  questionIconTooltip: {
    id: 'admin.portal.productTours.adminOnboarding.questionIcon.Tooltip',
    defaultMessage: 'Quick Start Guide',
    description: 'Tooltip for the question icon in the product tours component.',
  },
  welcomeModalNewUserTitle: {
    id: 'admin.portal.productTours.adminOnboarding.welcomeModal.title.new',
    defaultMessage: 'Welcome!',
    description: 'Title for the welcome modal for new users.',
  },
  welcomeModalNewUserBody: {
    id: 'admin.portal.productTours.adminOnboarding.welcomeModal.body.new',
    defaultMessage: 'We\'re excited to show you the edX administrative portal.'
    + ' Use our <b>Quick Start Guide</b> to get step-by-step guidance on what our portal can do for you.',
    description: 'Body for the welcome modal for new users.',
  },
  welcomeModalExistingUserTitle: {
    id: 'admin.portal.productTours.adminOnboarding.welcomeModal.title.existing',
    defaultMessage: 'Hello!',
    description: 'Title for the welcome modal for existing users.',
  },
  welcomeModalExistingUserBody: {
    id: 'admin.portal.productTours.adminOnboarding.welcomeModal.body.existing',
    defaultMessage: 'We\'ve launched a new <b>Quick Start Guide</b>, which provides'
    + ' step-by-step guidance on what our portal can do for you.',
    description: 'Body for the welcome modal for existing users.',
  },
  dismissConfirmationBody: {
    id: 'admin.portal.productTours.adminOnboarding.dismiss.modal.body',
    defaultMessage: 'You haven\'t completed all the steps yet. You can revisit the guide anytime--just '
    + 'click the help icon in the bottom right corner.',
    description: 'Body for the dismiss confirmation modal.',
  },
  dismissConfirmationTitle: {
    id: 'admin.portal.productTours.adminOnboarding.dismiss.modal.title',
    defaultMessage: 'Are you sure?',
    description: 'Title for the dismiss confirmation modal.',
  },
  trackLearnerProgressStepOneTitle: {
    id: 'adminPortal.productTours.adminOnboarding.trackLearnerProgress.title.1',
    defaultMessage: 'Track learner progress',
    description: 'Title for the learner progress tracking step',
  },
  trackLearnerProgressStepOneBody: {
    id: 'adminPortal.productTours.adminOnboarding.trackLearnerProgress.body.1',
    defaultMessage: 'Track learner activity and progress across courses with the Learner Progress Report.',
    description: 'Description for the learner progress tracking step one',
  },
  trackLearnerProgressStepTwoBody: {
    id: 'adminPortal.productTours.adminOnboarding.trackLearnerProgress.body.2',
    defaultMessage: 'Get a high-level view of learner enrollments, course completions, and more.',
    description: 'Description for the learner progress tracking step two',
  },
  trackLearnerProgressStepThreeBody: {
    id: 'adminPortal.productTours.adminOnboarding.trackLearnerProgress.body.4',
    defaultMessage: 'Scroll down for a detailed, twice-daily updated progress report.',
    description: 'Description for the learner progress tracking step four',
  },
  trackLearnerProgressStepFourBody: {
    id: 'adminPortal.productTours.adminOnboarding.trackLearnerProgress.body.5',
    defaultMessage: 'Access the full Learner Progress Report here.',
    description: 'Description for the learner progress tracking step five',
  },
  trackLearnerProgressStepFiveBody: {
    id: 'adminPortal.productTours.adminOnboarding.trackLearnerProgress.body.8',
    defaultMessage: 'View module-level details for Executive Education courses.',
    description: 'Description for the learner progress tracking step eight',
  },
  trackLearnerProgressStepSixBody: {
    id: 'adminPortal.productTours.adminOnboarding.trackLearnerProgress.body.6',
    defaultMessage: 'Filter results by course, start date, or learner email.',
    description: 'Description for the learner progress tracking step six',
  },
  trackLearnerProgressStepSevenBody: {
    id: 'adminPortal.productTours.adminOnboarding.trackLearnerProgress.body.7',
    defaultMessage: 'Export the report as a CSV to gain insights and organize data efficiently.',
    description: 'Description for the learner progress tracking step seven',
  },
  analyticsStepOneTitle: {
    id: 'adminPortal.productTours.adminOnboarding.analytics.title.1',
    defaultMessage: 'View enrollment insights',
    description: 'Title for the analytics step one',
  },
  analyticsStepOneBody: {
    id: 'adminPortal.productTours.adminOnboarding.analytics.body.1',
    defaultMessage: 'Explore insights about your learners and their enrollments. Adjust date ranges, granularity, and analytics type to view data on enrollments, engagement, completions, leaderboards, and skills tracking.',
    description: 'Description for the analytics tracking step one',
  },
  analyticsStepTwoBody: {
    id: 'adminPortal.productTours.adminOnboarding.analytics.body.2',
    defaultMessage: 'The Engagement tab will help you understand course enrollment, learning hours, top subjects, and completions by your learners. Filter data by date ranges, group, budget, and course.',
    description: 'Description for the analytics tracking step two',
  },
  analyticsStepThreeBody: {
    id: 'adminPortal.productTours.adminOnboarding.analytics.body.3',
    defaultMessage: 'The Progress tab will help you summarize completed courses by your learners. Filter data by date ranges, group, budget, and course.',
    description: 'Description for the analytics tracking step three',
  },
  analyticsStepFourBody: {
    id: 'adminPortal.productTours.adminOnboarding.analytics.body.4',
    defaultMessage: 'The Outcomes tab will help you visualize the skills your learner have gained from the courses. Filter data by date ranges, group, budget, and course.',
    description: 'Description for the analytics tracking step four',
  },
  organizeLearnersStepOneTitle: {
    id: 'adminPortal.productTours.adminOnboarding.organizeLearners.title.1',
    defaultMessage: 'Organize members',
    description: 'Title for the organize members flow step one',
  },
  organizeLearnersStepOneBody: {
    id: 'adminPortal.productTours.adminOnboarding.organizeLearners.body.1',
    defaultMessage: 'Create learner groups, view all learners in your organization, and access individual learner profiles—all in one place.',
    description: 'Description for the organize learners flow step one',
  },
  organizeLearnersStepOneWithAdminsBody: {
    id: 'adminPortal.productTours.adminOnboarding.organizeLearners.withAdmins.body.1',
    defaultMessage: 'Create learner groups, view all learners in your organization, access individual learner profiles, and manage admins—all in one place.',
    description: 'Description for the organize learners flow step one when the invite admins feature is enabled',
  },
  organizeLearnersStepOneNoMembersBody: {
    id: 'adminPortal.productTours.adminOnboarding.organizeLearners.noLearners.body.1',
    defaultMessage: 'Once learners join the organization, you can create learner groups, view all learners in your organization, and access individual learner profiles—all in one place.',
    description: 'Description for the organize learners flow step one if there are no enterprise members',
  },
  organizeLearnersStepTwoBody: {
    id: 'adminPortal.productTours.adminOnboarding.organizeLearners.body.2',
    defaultMessage: 'View all learners in your organization. Search by name and access profiles to track progress and view learning access.',
    description: 'Description for the organize learners flow step two',
  },
  organizeLearnersAdminsTabBody: {
    id: 'adminPortal.productTours.adminOnboarding.organizeLearners.body.adminsTab',
    defaultMessage: 'Manage and view your organization\'s admins.',
    description: 'Description for the organize learners flow step two for admins tab when the invite admins feature is enabled',
  },
  organizeLearnersStepThreeBody: {
    id: 'adminPortal.productTours.adminOnboarding.organizeLearners.body.3',
    defaultMessage: '"View more" allows you to see the learner\'s full profile with enrollments, access type, and group'
    + ' memberships at a glance.',
    description: 'Description for the organize learners flow step three',
  },
  organizeLearnersStepFourBody: {
    id: 'adminPortal.productTours.adminOnboarding.organizeLearners.body.4',
    defaultMessage: 'Organize members by creating groups for tracking and assignments.',
    description: 'Description for the organize members flow step four',
  },
  organizeLearnersStepFiveBody: {
    id: 'adminPortal.productTours.adminOnboarding.organizeLearners.body.5',
    defaultMessage: 'When you\'re ready, use "Create Group" to get started. <a>Learn more</a>.',
    description: 'Description for the organize learners flow step five',
  },
  organizeLearnersWithGroupsStepFourBody: {
    id: 'adminPortal.productTours.adminOnboarding.organizeLearners.withGroups.body.4',
    defaultMessage: 'View, manage, and create your learner groups here.',
    description: 'Description for the organize learners flow with groups step four',
  },
  organizeLearnersWithGroupsStepFiveBody: {
    id: 'adminPortal.productTours.adminOnboarding.organizeLearners.withGroups.body.5',
    defaultMessage: '“Create Group" allows you to add more learner groups. <a>Learn more</a>.',
    description: 'Description for the organize learners flow with groups step five',
  },
  organizeLearnersWithGroupsStepSixBody: {
    id: 'adminPortal.productTours.adminOnboarding.organizeLearners.withGroups.body.6',
    defaultMessage: '"View group" allows you to edit group details, add and remove learners, or track learner\'s progress.',
    description: 'Description for the organize learners flow with groups step six',
  },

  administerSubscriptionsTitle: {
    id: 'adminPortal.productTours.adminOnboarding.administerSubscriptions.title',
    defaultMessage: 'Administer subscriptions',
    description: 'Title for the administer subscriptions step',
  },
  administerSubscriptionsStepOneBody: {
    id: 'adminPortal.productTours.adminOnboarding.administerSubscriptions.body.1',
    defaultMessage: 'Manage your subscription plans and give learners access to self-enroll in courses. '
    + 'Invite learners, track usage, and manage licenses--all in one place.',
    description: 'Description for the administer subscriptions flow step one',
  },
  administerSubscriptionsStepOneBodySingleSub: {
    id: 'adminPortal.productTours.adminOnboarding.administerSubscriptions.body.1.single',
    defaultMessage: 'Manage your subscription plan and give learners access to self-enroll in courses. '
    + 'Invite learners, track usage, and manage licenses--all in one place.',
    description: 'Description for the administer subscriptions flow step one',
  },
  administerSubscriptionsStepTwoBody: {
    id: 'adminPortal.productTours.adminOnboarding.administerSubscriptions.body.2',
    defaultMessage: 'The list below shows active and expired subscription plans for you to view and manage.',
    description: 'Description for the administer subscriptions flow step two',
  },
  administerSubscriptionsStepThreeBody: {
    id: 'adminPortal.productTours.adminOnboarding.administerSubscriptions.body.3',
    defaultMessage: '"Manage learners" allows you to view more details about a plan. Let\'s view your learners now.',
    description: 'Description for the administer subscriptions flow step three',
  },
  administerSubscriptionsStepFourBody: {
    id: 'adminPortal.productTours.adminOnboarding.administerSubscriptions.body.4',
    defaultMessage: 'On the subscription plan details page, you can check the expiration date, invite learners, and manage licenses.',
    description: 'Description for the administer subscriptions flow step four',
  },
  administerSubscriptionsStepFiveBody: {
    id: 'adminPortal.productTours.adminOnboarding.administerSubscriptions.body.5',
    defaultMessage: '"Invite Learners" allows you to invite learners to your subscription plan.',
    description: 'Description for the administer subscriptions flow step five',
  },
  administerSubscriptionsStepSixBody: {
    id: 'adminPortal.productTours.adminOnboarding.administerSubscriptions.body.6',
    defaultMessage: 'The License Allocation section lets you see invited learners, track license status, and revoke licenses as needed.',
    description: 'Description for the administer subscriptions flow step six',
  },
  administerSubscriptionsStepSevenBody: {
    id: 'adminPortal.productTours.adminOnboarding.administerSubscriptions.body.7',
    defaultMessage: 'Use filters to sort invited learners by license status or search by email address.',
    description: 'Description for the administer subscriptions flow step seven',
  },
  administerSubscriptionsStepEightBody: {
    id: 'adminPortal.productTours.adminOnboarding.administerSubscriptions.body.8',
    defaultMessage: 'To view more plans, navigate back to Subscription Management using this button or the main menu.',
    description: 'Description for the administer subscriptions flow step eight',
  },
  allocateLearningBudgetTitle: {
    id: 'adminPortal.productTours.adminOnboarding.allocateLearningBudget.title',
    defaultMessage: 'Allocate learning budget',
    description: 'Description for the allocate learning budgets flow step one title',
  },
  allocateLearningBudgetStepOneBody: {
    id: 'adminPortal.productTours.adminOnboarding.allocateLearningBudget.body.1',
    defaultMessage: 'Manage Learner Credit budgets to invite learners to enroll or assign courses directly.',
    description: 'Description for the allocate learning budgets flow step one body',
  },
  allocateLearningBudgetStepTwoAssignment: {
    id: 'adminPortal.productTours.adminOnboarding.allocateLearningBudget.body.3a',
    defaultMessage: 'Let\'s view your Assignment budget.',
    description: 'Description for the allocate learning budgets flow step three for assignment budget',
  },
  allocateLearningBudgetStepTwoBnE: {
    id: 'adminPortal.productTours.adminOnboarding.allocateLearningBudget.body.2.bne',
    defaultMessage: 'Let\'s view your Browse and Enroll budget.',
    description: 'Description for the allocate learning budgets flow step three for Browse and Enroll budget',
  },
  allocateLearningBudgetStepThreeAssignment: {
    id: 'adminPortal.productTours.adminOnboarding.allocateLearningBudget.body.3.assignment',
    defaultMessage: 'The budget detail card provides an overview of your budget, including its type, expiration date, and balance.',
    description: 'Description for the allocate learning budgets assignment flow step three',
  },
  allocateLearningBudgetStepThreeBnE: {
    id: 'adminPortal.productTours.adminOnboarding.allocateLearningBudget.body.3.bne',
    defaultMessage: 'The budget provides an overview of your budget, including its expiration date, type, access permissions, and balance.',
    description: 'Description for the allocate learning budgets bne flow step three',
  },
  allocateLearningBudgetStepFourAssignment: {
    id: 'adminPortal.productTours.adminOnboarding.allocateLearningBudget.body.4.assignment',
    defaultMessage: '"New Assignment" allows you to assign courses to learners from your catalog.',
    description: 'Description for the allocate learning budgets flow step four',
  },
  allocateLearningBudgetStepFourBnE: {
    id: 'adminPortal.productTours.adminOnboarding.allocateLearningBudget.body.4.bne',
    defaultMessage: 'Track all budget activity, including enrollment spending using the “Activity” tab.',
    description: 'Description for the allocate learning budgets bne flow step four',
  },
  allocateLearningBudgetStepFourInviteBnE: {
    id: 'adminPortal.productTours.adminOnboarding.allocateLearningBudget.body.4.inviteBne',
    defaultMessage: '"New members" can be used to invite learners to utilize this budget.',
    description: 'Description for the allocate learning budgets invite-only bne flow step four',
  },
  allocateLearningBudgetStepFiveAssignment: {
    id: 'adminPortal.productTours.adminOnboarding.allocateLearningBudget.body.5.assignment',
    defaultMessage: 'Track all budget activity, including pending assignments and enrollment spending.',
    description: 'Description for the allocate learning budgets assignments flow step five',
  },
  allocateLearningBudgetStepFiveAssignmentZeroState: {
    id: 'adminPortal.productTours.adminOnboarding.allocateLearningBudget.body.5.assignment.zeroState',
    defaultMessage: 'Once learners are using this budget, you\'ll be able to track all activity, including enrollment'
    + ' spending on the "Activity" tab.',
    description: 'Description for the allocate learning budgets flow step five zero state',
  },
  allocateLearningBudgetStepFiveInviteBnE: {
    id: 'adminPortal.productTours.adminOnboarding.allocateAssignmentBudget.body.5.inviteBne',
    defaultMessage: 'Use the Catalog tab to browse courses available to your learners.',
    description: 'Description for the allocate learning budgets flow step five',
  },
  allocateLearningBudgetStepSixAssignmentZeroState: {
    id: 'adminPortal.productTours.adminOnboarding.allocateLearningBudget.body.6.assignment.zeroState',
    defaultMessage: 'Use the Catalog tab to browse available courses and assign them directly to learners.',
    description: 'Description for the allocate learning budgets flow step six for zero state.',
  },
  allocateLearningBudgetStepSixInviteBnE: {
    id: 'adminPortal.productTours.adminOnboarding.allocateAssignmentBudget.body.6.inviteBne',
    defaultMessage: 'View all learners invited to this budget, along with their status (Accepted, Invited, Removed),'
    + ' enrollments, and the option to remove members from the budget.',
    description: 'Description for the allocate learning budgets invite only Browse and Enroll flow step six',
  },
  allocateLearningBudgetStepSixAssignment: {
    id: 'adminPortal.productTours.adminOnboarding.allocateLearningBudget.body.6.assignment',
    defaultMessage: 'The Assigned table helps you monitor learner assignments, send reminders, or cancel as needed.',
    description: 'Description for the allocate learning budgets flow step six',
  },
  allocateLearningBudgetStepSixSpendNoAssignment: {
    id: 'adminPortal.productTours.adminOnboarding.allocateLearningBudget.body.6.spendNoAssignment',
    defaultMessage: 'Once you assign courses, you can monitor learner assignments, send reminders, or cancel as needed.',
    description: 'Description for the allocate learning budgets flow step six for customers that have spend but no assignments.',
  },
  allocateLearningBudgetStepSevenAssignment: {
    id: 'adminPortal.productTours.adminOnboarding.allocateLearningBudget.body.8.assignment',
    defaultMessage: 'The Spent table allows you to review spending details for this budget.',
    description: 'Description for the allocate learning budgets flow step eight',
  },
  allocateLearningBudgetStepEightAssignment: {
    id: 'adminPortal.productTours.adminOnboarding.allocateAssignmentBudget.body.9.assignment',
    defaultMessage: 'Use the Catalog tab to browse available courses and assign them directly to learners.',
    description: 'Description for the allocate learning budgets flow step nine',
  },
  allocateLearningBudgetStepNine: {
    id: 'adminPortal.productTours.adminOnboarding.allocateAssignmentBudget.body.10',
    defaultMessage: 'To view more budgets, return to Learner Credit Management using the breadcrumbs or left-hand navigation.',
    description: 'Description for the allocate learning budgets flow step ten',
  },
  administerSubscriptionsStepNineBody: {
    id: 'adminPortal.productTours.adminOnboarding.administerSubscriptions.body.9',
    defaultMessage: 'Review and manage course requests from your learners.',
    description: 'Description for the administer subscriptions flow step nine',
  },
  viewCustomizeReportsTitle: {
    id: 'adminPortal.productTours.adminOnboarding.customizeReports.title',
    defaultMessage: 'Customize reports',
    description: 'Title for the customize reports step',
  },
  viewCustomizeReports: {
    id: 'adminPortal.productTours.adminOnboarding.customizeReports.title.1',
    defaultMessage: 'Automate reporting on learner engagement, progress, and catalog activity. Set up reports to be delivered '
      + 'to your email daily, weekly, or monthly for easy tracking.',
    description: 'Description for the customize reports step',
  },
  viewSetUpPreferencesTitle: {
    id: 'adminPortal.productTours.adminOnboarding.setUpPreferences.title',
    defaultMessage: 'Set up preferences',
    description: 'Title for the set up preferences step',
  },
  viewSetUpPreferences: {
    id: 'adminPortal.productTours.adminOnboarding.setUpPreferences.title.1',
    defaultMessage: 'Customize and configure your portal to fit your organization\'s needs. Set up branding, '
      + 'manage learner access, enable SSO, and integrate learning platforms—all in one place.',
    description: 'Description for the set up preferences step',
  },
  editHighlightsStepOneTitle: {
    id: 'adminPortal.productTours.adminOnboarding.editHighlights.title.1',
    defaultMessage: 'Showcase courses',
    description: 'Title for the Quick Start Guide entry that opens the edit highlights flow',
  },
  editHighlightsPopupOneTitle: {
    id: 'adminPortal.productTours.adminOnboarding.editHighlights.popup.title.1',
    defaultMessage: 'Showcase courses',
    description: 'Title shown inside the first popup of the edit highlights flow',
  },
  editHighlightsDismissButton: {
    id: 'adminPortal.productTours.adminOnboarding.editHighlights.dismiss',
    defaultMessage: 'Dismiss',
    description: 'Label for the dismiss button on the first step of the edit highlights flow',
  },
  editHighlightsStepOneBody: {
    id: 'adminPortal.productTours.adminOnboarding.editHighlights.body.1',
    defaultMessage: 'Showcase selected courses to your learners with Highlights.',
    description: 'Description for the edit highlights flow step one — discover active highlights',
  },
  editHighlightsStepTwoBody: {
    id: 'adminPortal.productTours.adminOnboarding.editHighlights.body.2',
    defaultMessage: 'View and manage your published Highlights here.',
    description: 'Description for the edit highlights flow step two — review existing highlights',
  },
  editHighlightsStepThreeBody: {
    id: 'adminPortal.productTours.adminOnboarding.editHighlights.body.3',
    defaultMessage: 'Create a Highlight by selecting this button. Add up to 24 courses, name your Highlight, and publish it. <a>Learn more</a>.',
    description: 'Description for the edit highlights flow step three — create a highlight',
  },
  editHighlightsStepFourBody: {
    id: 'adminPortal.productTours.adminOnboarding.editHighlights.body.4',
    defaultMessage: 'Control who can see your Highlights by adjusting catalog visibility.',
    description: 'Description for the edit highlights flow step four — catalog visibility',
  },
  editHighlightsStepFiveBody: {
    id: 'adminPortal.productTours.adminOnboarding.editHighlights.body.5',
    defaultMessage: 'To view details or edit a specific Highlight, select its card.',
    description: 'Description for the edit highlights flow step five — view or edit a specific highlight',
  },
  completeTourModalTitle: {
    id: 'adminPortal.productTours.adminOnboarding.completeTour.modalTitle',
    defaultMessage: 'Great job!',
    description: 'Description for the complete tour modal title',
  },
  completeTourModal: {
    id: 'adminPortal.productTours.adminOnboarding.completeTour.modal',
    defaultMessage: 'You\'ve completed the Quick Start Guide and are ready to administer learning. Need a refresher? Access this guide anytime from the help icon below.',
    description: 'Description for the complete tour modal',
  },
});

export default messages;
